import { render, staticRenderFns } from "./CardMini.vue?vue&type=template&id=5de178d2&scoped=true&"
import script from "./CardMini.vue?vue&type=script&lang=js&"
export * from "./CardMini.vue?vue&type=script&lang=js&"
import style0 from "./CardMini.vue?vue&type=style&index=0&id=5de178d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de178d2",
  null
  
)

export default component.exports